/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Common_Sign_Resend_Verification_CountdownInputs */

const en_common_sign_resend_verification_countdown = /** @type {(inputs: Common_Sign_Resend_Verification_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Resend in ${i?.seconds}s`)
};

const zh_common_sign_resend_verification_countdown = /** @type {(inputs: Common_Sign_Resend_Verification_CountdownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} 秒后可重新发送`)
};

/**
* | output |
* | --- |
* | "Resend in {seconds}s" |
*
* @param {Common_Sign_Resend_Verification_CountdownInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_sign_resend_verification_countdown = /** @type {((inputs: Common_Sign_Resend_Verification_CountdownInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_Resend_Verification_CountdownInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_sign_resend_verification_countdown(inputs)
	return zh_common_sign_resend_verification_countdown(inputs)
});
export { common_sign_resend_verification_countdown as "common.sign.resend_verification_countdown" }